module.exports = __webpack_public_path__ + "media/images/about-members-db3e54420f05a2df5375a2cf53a93ec3.png";